import { ConfigProvider, theme } from "antd";
import { useEffect } from "react";
import "./globals.css";
import {
  THEME_BUTTON_COLORS,
  THEME_CARD_COLORS,
  THEME_COLORS,
  THEME_FONT_FAMILY,
  THEME_SHADOWS,
  THEME_SHAPE,
  THEME_UI_COLORS,
  applyThemeCssVariables,
} from "./theme.palette";

export const AntdConfig = ({ children }) => {
  useEffect(() => {
    applyThemeCssVariables();
  }, []);

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontFamily: THEME_FONT_FAMILY,
          colorPrimary: THEME_COLORS.primary,
          colorSecondary: THEME_COLORS.secondary,
          colorAccent: THEME_COLORS.secondary,
          colorSuccess: THEME_COLORS.success,
          colorWarning: THEME_COLORS.warning,
          colorError: THEME_COLORS.danger,
          colorText: THEME_COLORS.text,
          colorTextHeading: THEME_COLORS.textHeading,
          colorTextSecondary: THEME_COLORS.textSecondary,
          colorTextTertiary: THEME_COLORS.textTertiary,
          colorTextPlaceholder: THEME_COLORS.textPlaceholder,
          colorTextDisabled: THEME_COLORS.textDisabled,
          colorTextInverse: THEME_COLORS.textInverse,
          borderRadius: THEME_SHAPE.hasBorderRadius ? 8 : 0,
          colorBgLayout: THEME_COLORS.backgroundLayout,
          colorBgContainer: THEME_COLORS.backgroundContainer,
          colorBgElevated: THEME_COLORS.backgroundElevated,
          colorBgOverlay: THEME_COLORS.backgroundOverlay,
          colorBorder: THEME_COLORS.border,
          boxShadow: THEME_SHADOWS.md,
          boxShadowSecondary: THEME_SHADOWS.xl,
        },
        components: {
          Button: {
            borderRadius: THEME_SHAPE.hasBorderRadius ? 8 : 0,
            boxShadow: "none",
            primaryShadow: "none",
            dangerShadow: "none",
            colorPrimary: THEME_BUTTON_COLORS.allBg,
            colorPrimaryHover: THEME_BUTTON_COLORS.allHoverBg,
            colorPrimaryActive: THEME_BUTTON_COLORS.allHoverBg,
            primaryColor: THEME_BUTTON_COLORS.allText,
            defaultBg: THEME_BUTTON_COLORS.allBg,
            defaultColor: THEME_BUTTON_COLORS.allText,
            defaultBorderColor: THEME_BUTTON_COLORS.allHoverBg,
            defaultHoverBg: THEME_BUTTON_COLORS.allHoverBg,
            defaultHoverColor: THEME_BUTTON_COLORS.allText,
            defaultHoverBorderColor: THEME_BUTTON_COLORS.allHoverBg,
            defaultActiveBg: THEME_BUTTON_COLORS.allHoverBg,
            defaultActiveColor: THEME_BUTTON_COLORS.allText,
            defaultActiveBorderColor: THEME_BUTTON_COLORS.allHoverBg,
            colorTextLightSolid: THEME_BUTTON_COLORS.allText,

            successBg: THEME_BUTTON_COLORS.allBg,
            successColor: THEME_BUTTON_COLORS.allText,
            successBorderColor: THEME_BUTTON_COLORS.allHoverBg,

            warningBg: THEME_BUTTON_COLORS.allBg,
            warningColor: THEME_BUTTON_COLORS.allText,
            warningBorderColor: THEME_BUTTON_COLORS.allHoverBg,

            dangerBg: THEME_BUTTON_COLORS.allBg,
            dangerColor: THEME_BUTTON_COLORS.allText,
            dangerBorderColor: THEME_BUTTON_COLORS.allHoverBg,

            ghostBg: THEME_BUTTON_COLORS.ghostBg,
            ghostColor: THEME_BUTTON_COLORS.ghostText,
            ghostBorderColor: THEME_BUTTON_COLORS.ghostBorder,

            hoverBg: THEME_BUTTON_COLORS.hoverBg,
            hoverBorderColor: THEME_BUTTON_COLORS.hoverBorder,
          },
          Card: {
            colorBgContainer: THEME_CARD_COLORS.background,
            borderColor: THEME_CARD_COLORS.border,
            boxShadow: THEME_SHADOWS.lg,
            backdropFilter: "blur(10px)",
            bodyPadding: 0,
          },
          Modal: {
            colorBgContainer: THEME_UI_COLORS.modalBackground,
            contentPadding: 0,
            boxShadow: THEME_UI_COLORS.modalShadow,
          },
          Header: {
            colorText: THEME_UI_COLORS.headerText,
            colorTextSecondary: THEME_UI_COLORS.mutedText,
            colorTextDisabled: THEME_COLORS.textDisabled,
            colorTextPlaceholder: THEME_COLORS.textPlaceholder,
            colorTextInverse: THEME_UI_COLORS.headerTextInverse,
            colorBgContainer: "transparent",
          },
          Menu: {
            itemBorderRadius: THEME_SHAPE.hasBorderRadius ? 8 : 0,
            itemActiveBg: THEME_COLORS.primary,
            itemSelectedBg: THEME_COLORS.primary,
            itemSelectedColor: THEME_COLORS.textInverse,
            itemColor: THEME_COLORS.menuItem,
            colorBgContainer: THEME_UI_COLORS.menuBackground,
            boxShadow: THEME_UI_COLORS.menuShadow,
            itemHoverBg: THEME_UI_COLORS.menuHoverBackground,
            itemHoverColor: THEME_COLORS.textInverse,
          },
          Typography: {
            fontFamily: THEME_FONT_FAMILY,
            colorText: THEME_COLORS.text,
            colorTextSecondary: THEME_UI_COLORS.mutedText,
            colorTextDisabled: THEME_COLORS.textDisabled,
            colorTextPlaceholder: THEME_COLORS.textPlaceholder,
            colorTextInverse: THEME_COLORS.textInverse,
            colorBgContainer: "transparent",
          },
          Flex: {
            colorBgContainer: "transparent",
          },
          Input: {
            colorText: THEME_COLORS.text,
            colorTextSecondary: THEME_UI_COLORS.mutedText,
            colorTextDisabled: THEME_COLORS.textDisabled,
            colorTextPlaceholder: THEME_COLORS.textPlaceholder,
            colorTextInverse: "white",
            borderRadius: THEME_SHAPE.hasBorderRadius ? 8 : 0,
            colorBorder: THEME_UI_COLORS.inputBorder,
            controlHeight: 40,
          },
          Select: {
            borderRadius: THEME_SHAPE.hasBorderRadius ? 8 : 0,
            controlHeight: 40,
            colorBorder: THEME_UI_COLORS.inputBorder,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
